module.exports = __webpack_public_path__ + "svg/drama.svg";